import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTabsModule } from '@angular/material/tabs';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzSpinModule } from 'ng-zorro-antd/spin';

import { ToastModule } from '@libs/src/toast/toast.module';
import { EventParticipantsModule } from '@main-client/src/app/events/event-participants/event-participants.module';
import { OpportunityStoreModule } from '@main-client/src/app/opportunity/opportunity-store.module';
import { CancelledOpportunitySubmissionsPipeModule } from '@main-client/src/app/pipes/cancelled-opportunity-submissions-pipe/cancelled-opportunity-submissions-pipe.module';
import { ConfirmedOpportunitySubmissionsPipeModule } from '@main-client/src/app/pipes/confirmed-opportunity-submissions-pipe/confirmed-opportunity-submissions-pipe.module';
import { WaitlistedOpportunitySubmissionsPipeModule } from '@main-client/src/app/pipes/waitlisted-opportunity-submissions-pipe/waitlisted-opportunity-submissions-pipe.module';
import { ProgressSpinnerModule } from '@main-client/src/app/progress-spinner/progress-spinner.module';

import { EventSubmissionsDialogComponent } from './event-submissions-dialog.component';

@NgModule({
  imports: [
    CancelledOpportunitySubmissionsPipeModule,
    CommonModule,
    ConfirmedOpportunitySubmissionsPipeModule,
    EventParticipantsModule,
    FlexLayoutModule,
    MatButtonModule,
    MatDialogModule,
    MatTabsModule,
    NzIconModule,
    NzSpinModule,
    OpportunityStoreModule,
    ProgressSpinnerModule,
    ToastModule,
    WaitlistedOpportunitySubmissionsPipeModule,
  ],
  declarations: [EventSubmissionsDialogComponent],
  exports: [EventSubmissionsDialogComponent],
})
export class EventSubmissionsDialogModule {}
